import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import dr1 from "../../assets/gst/2.jpg";
import { IoArrowBackCircle } from "react-icons/io5";

import { AiFillHome, AiOutlineAppstore } from "react-icons/ai"; // Import the simpler icon
import axios from "axios";
import {
  showCustomToast,
  CustomToastContainer,
} from "../../components/CustomToast";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../context/auth";
import LoginModal from "../../components/LoginModel"; // Import the modal
import { AiOutlineLoading } from "react-icons/ai";
import TermsModal from "../../components/TermsModal.jsx";

const FullScreenLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="text-center">
        <AiOutlineLoading
          className="mx-auto mb-4 text-white animate-spin"
          size={64}
        />
        <p className="text-white text-xl font-semibold">
          Processing your application...
        </p>
        <p className="text-white text-sm mt-2">
          Please do not close the window
        </p>
      </div>
    </div>
  );
};

const Gst_return_filing = () => {
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
  const [auth] = useAuth(); // Access auth state from context
  const isLoggedIn = Boolean(auth.token); // Determine if user is logged in based on token
  const [formPrices, setFormPrices] = useState({}); // State for form prices
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [txn_id, setTxnId] = useState(null);

  const [transactionID, setTransactionID] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // New loading state
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isTermsActive, setIsTermsActive] = useState(false);
  const [wasTermsModalOpened, setWasTermsModalOpened] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    // Show the modal if the user is not logged in
    if (!isLoggedIn) {
      setIsModalOpen(true); // Show the modal if not logged in
    }
  }, [isLoggedIn]); // Run effect whenever isLoggedIn changes

  const closeModal = () => {
    setIsModalOpen(false); // Function to close modal
  };
  const openTermsModal = (e) => {
    e.preventDefault();
    setIsTermsModalOpen(true);
  };

  const handleTermsModalOpen = () => {
    setWasTermsModalOpened(true);
  };
  useEffect(() => {
    if (isTermsActive) {
      setIsChecked(true);
    }
  }, [isTermsActive]);

  useEffect(() => {
    // Fetch form prices from the backend
    const fetchFormPrices = async () => {
      try {
        const response = await axios.get(
          "https://api.makeeasydocuments.com/api/formprices/getallformprice"
        );
        const prices = response.data.reduce((acc, formPrice) => {
          acc[formPrice.formType] = formPrice.price;
          return acc;
        }, {});
        setFormPrices(prices);
        setSelectedPrice(prices["gst_Return_Registration"] || 0); // Default price for foodLicenseYear1
      } catch (error) {
        console.error("Error fetching form prices:", error);
        showCustomToast("Error fetching form prices.", "error");
      }
    };

    fetchFormPrices();
  }, []);

  // Define the initial form data
  const initialFormData = {
    application_type: "Gst Return Filing",
    gstNumber: "",
    fullName: "",
    email: "",
    address: "",
    state: "",
    pincode: "",
    mobileNumber: "",
    dateOfBirth: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const generateTransactionID = () => {
    const timeStamp = Date.now();
    const randomNum = Math.floor(Math.random() * 1000000);
    const merchantPrefix = "T";
    const transactionID = `${merchantPrefix}${timeStamp}${randomNum} `;
    return setTransactionID(transactionID);
  };

  useEffect(() => {
    generateTransactionID(); // Only run once on initial load
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Check if the terms modal was opened
    if (!wasTermsModalOpened) {
      alert("Please open the terms and conditions modal before submitting.");
      setIsLoading(false); // Stop loading if condition is not met
      return; // Stop further execution
    }

    // Check if the terms and conditions checkbox is checked
    if (!isChecked) {
      alert("Please agree to the terms and conditions by checking the box.");
      setIsLoading(false); // Stop loading if condition is not met
      return; // Stop further execution
    }

    console.log("Form data before submission:", formData); // Log the form data

    // Check if user is authenticated
    if (!auth.token) {
      showCustomToast("Please log in to fill out the form.");
      return;
    }
    setIsLoading(true);

    const formDataToSubmit = {
      ...formData,
      transactionId: transactionID, // Include the transaction ID in the request body
    };
    console.log("form data before sending", formDataToSubmit);

    try {
      // Set up headers for the request
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`, // Include the token in the header if needed
        },
      };

      const response = await axios.post(
        "https://api.makeeasydocuments.com/api/commonForm/createcommon-form",
        formDataToSubmit,
        config // Include the config object
      );

      let formID;
      let formType;
      let userId;

      if (
        response.data &&
        response.data.newCommonForm &&
        response.data.newCommonForm._id
      ) {
        // Extract the form ID from the response
        formID = response.data.newCommonForm._id;
        formType = response.data.newCommonForm._id;
        userId  = response.data.newCommonForm.user;

        console.log("Form ID:", formID);
        //
      } else {
        console.error("Unexpected response format:", response.data);
      }

      // Proceed with the PayU payment logic after form submission
      const payuResponse = await axios.post(
        "https://api.makeeasydocuments.com/api/payu/hash",
        {
          formId: formID, // 👈 Add this line to send formId
          formType: "Gst Return Filing",
          fullName: formData.fullName,
          email: formData.email,
          amount: selectedPrice,
          transactionID,
          udf1: "detail 1",
          udf2: "detail 2",
          udf3: "",
          udf4: "",
          udf5: "",
        }
      );

      const { hash } = payuResponse.data;

      const payuForm = document.createElement("form");
      payuForm.action = "https://api.makeeasydocuments.com/get-payment";
      payuForm.method = "POST";

      const fields = {
        userId: userId,
        formId: formID,
        formType: "Gst Return Filing",
        key: "nC1EmY",
        txnid: transactionID,
        amount: selectedPrice,
        productinfo: "Gst Return Filing",
        firstname: formData.fullName,
        email: formData.email,
        phone: formData.mobileNumber,
        surl: `https://makeeasydocuments.com/success_payment?txnid=${transactionID}`, // Frontend success page
        furl: `https://makeeasydocuments.com/payment-failed`, // Frontend failure page
        hash: hash,
        udf1: "detail 1",
        udf2: "detail 2",
        udf3: "",
        udf4: "",
        udf5: "",
      };

      for (const key in fields) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = fields[key];
        payuForm.appendChild(input);
      }

      document.body.appendChild(payuForm);
      payuForm.submit();
      console.log(response.data); // Handle the response as needed

      // Reset the form fields to their initial state after successful submission
      setFormData(initialFormData);
    } catch (error) {
      showCustomToast("Error submitting the form. Please try again.", "error");
      console.error(error.response ? error.response.data : error); // Handle the error as needed
    } finally {
      setIsLoading(false); // Stop the loading spinner in both success and error cases
    }
  };

  return (
    <div>
      <Header />
      {/* Page Title */}
      <div className="page-title py-6 bg-slate-300" data-aos="fade">
        <div className="container mx-auto px-4 lg:px-20 flex flex-col lg:flex-row justify-between items-start lg:items-center">
          {/* Title */}
          <h1 className=" text-black text-xl md:text-2xl font-semibold">
            GST Return Filing
          </h1>

          {/* Refund message */}
          <style jsx>{`
            @keyframes intenseBlink {
              0%,
              100% {
                opacity: 1;
                color: #f20000;
              }
              20% {
                opacity: 1;
                color: #000000;
              }
            }
          `}</style>
          <h1
            className="
      text-lg md:text-xl font-bold underline underline-offset-8 
      mb-2 lg:mb-0 lg:ml-4 
      animate-[intenseBlink_1s_ease-in-out_infinite]
    "
          >
            100% Fees Refundable, if Service is not Completed!
          </h1>

          {/* Breadcrumbs */}
          <nav className="breadcrumbs">
            <ol className="flex space-x-4 text-sm">
              <li>
                <Link
                  to={"/ "}
                  className="text-black hover:underline hover:text-black text-base"
                >
                  Home
                </Link>
              </li>

              <li className="text-black">/</li>
              <li>
                <Link
                  to={"/gst"}
                  className="flex items-center text-black hover:underline hover:text-black text-base"
                >
                  Go Back
                  <IoArrowBackCircle className="h-5 w-5 mr-2 ml-2" />{" "}
                  {/* Icon with margin */}
                </Link>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container mx-auto py-10 px-4">
        {/* Main Container */}
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold border-b-4 border-orange-600 inline-block pb-2">
            GST Return Filing
          </h2>
        </div>

        {/* Flex container to separate content */}
        <div className="flex flex-col pl-7 pr-7 lg:flex-row justify-between items-center gap-8">
          {/* Left Section (Text & Buttons) */}
          <div className="bg-white p-10 rounded-lg shadow-xl">
            <form onSubmit={handleSubmit}>
              <br />
              <div className="flex flex-col sm:flex-row sm:justify-between mt-10 pb-6">
                <h2 className="text-green-600 font-semibold text-xl text-center sm:text-left">
                  Service Charge :{" "}
                  <span className="text-red-600" id="formprice">
                    {" "}
                    ₹ {selectedPrice}
                  </span>
                </h2>
              </div>{" "}
              <br />
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-semibold mb-2">
                    Enter Full Name
                  </label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    placeholder="---"
                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-2">
                    GST Number
                  </label>
                  <input
                    type="text"
                    name="gstNumber"
                    value={formData.gstNumber}
                    onChange={handleInputChange}
                    placeholder="---"
                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-2">
                    Your Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="example@gmail.com" // Placeholder for guidance
                    className={`w-full border ${
                      formData.email && !formData.email.includes("@")
                        ? "border-red-500"
                        : "border-gray-300"
                    } rounded px-3 py-2 focus:outline-none`}
                    required
                    pattern="[a-zA-Z0-9._%+-]+@gmail\.com" // Regex pattern for Gmail addresses
                    title="Please enter a valid Gmail address." // Error message for invalid input
                    onBlur={(e) => {
                      // Validate on input blur
                      if (!e.target.value.includes("@")) {
                        e.target.setCustomValidity(
                          'You must include "@" in your email.'
                        );
                      } else {
                        e.target.setCustomValidity(""); // Clear the error
                      }
                    }}
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-2">
                    Address
                  </label>
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    placeholder="---"
                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-2">
                    State
                  </label>
                  <input
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    placeholder="---"
                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-2">
                    Pincode
                  </label>
                  <input
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleInputChange}
                    placeholder="---"
                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                    pattern="\d{6}" // Require exactly 6 digits
                    maxLength="6"
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 6);
                    }}
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-2">
                    Mobile Number
                  </label>
                  <input
                    type="text"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    placeholder="---"
                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    } // Only allows digits
                    pattern="[0-9]{10}"
                    maxLength="10"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-2">
                    Date of Birth
                  </label>
                  <input
                    type="date"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleInputChange}
                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                    required
                  />
                </div>
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    className="w-4 h-4"
                    required
                    checked={isChecked}
                    onChange={(e) => {
                      if (wasTermsModalOpened) {
                        setIsChecked(e.target.checked);
                      } else {
                        alert(
                          "Please open the terms and conditions modal before checking the box."
                        );
                      }
                    }}
                  />
                  <span>
                    {" "}
                    I agree to submit this form and accept the{" "}
                    <a
                      href="#"
                      onClick={openTermsModal}
                      className="text-blue-600 underline"
                    >
                      <br />
                      terms & conditions
                    </a>
                    .
                  </span>
                </label>

                {/* Terms Modal Component with tracking callback */}
                <TermsModal
                  isOpen={isTermsModalOpen}
                  setIsOpen={setIsTermsModalOpen}
                  setIsTermsActive={setIsTermsActive}
                  onModalOpen={handleTermsModalOpen}
                />
              </div>
              <button
                type="submit"
                className="w-full bg-green-600 font-semibold text-white py-3 mt-5 rounded-md hover:bg-green-700 transition-all duration-200 tracking-wide"
              >
                SUBMIT
              </button>
            </form>
          </div>

          {/* Image section with hover effect */}
          <div className="flex-1 flex justify-center items-center">
            <img
              src={dr1} // Replace with the correct path for the driving license image
              alt=" Make Easy Documents Driving License"
              className="w-full h-auto max-w-lg lg:max-w-xl xl:max-w-2xl object-contain transform transition-transform duration-500 hover:scale-105 hover:rotate-0 shadow-lg hover:shadow-2xl rounded-lg"
            />
          </div>
        </div>
      </div>
      {/* Render Login Modal only if not logged in */}
      {!isLoggedIn && isModalOpen && <LoginModal closeModal={closeModal} />}
      <CustomToastContainer />
      <Footer />
    </div>
  );
};

export default Gst_return_filing;
